export default [
  {
    path: "/settings/users",
    name: "users",
    meta: {
      permissions: {
        roles: ["administrator", "superadmin"],
        redirectTo: "/401"
      },
      title: "ADMIN_USERS_TITLE_2"
    },
    component: () => import(/* webpackChunkName: "Users" */ "./users/Users.vue")
  },
  {
    path: "/changeUserPassword",
    name: "changeUserPassword",
    meta: {
      permissions: {
        roles: ["driver",
                "office",
                "superadmin",
                "administrator"],
        redirectTo: "/401"
      },
      title: "ADMIN_UPDATE_PASSWORD"
    },
    component: () =>
      import(/* webpackChunkName: "ChangeUserPassword" */ "./ChangeUserPassword.vue")
  },
  {
    path: "/audit-history",
    name: "auditHistory",
    meta: {
      permissions: {
        roles: ["administrator", "superadmin"],
        redirectTo: "/401"
      },
      title: "AUDIT_HISTORY_TITLE"
    },
    component: () => import(/* webpackChunkName: "AuditHistory" */ "./AuditHistory.vue")
  }
];
